<template>
<div id="reporte_directo_ds" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Consulta Directa DS" class="elevation-1 px-5 py-3" >
          <v-form ref="form" lazy-validation>
            <v-card-text>
              <v-card-title>
                <span class="headline" ></span>
              </v-card-title>

              <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                  <v-flex s12 m6 l6>
                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }" >
                        <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                            :rules="[verificaPedimento, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                      </template>

                      <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu1 = false" >
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex s12 m6 l6>
                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }" >
                        <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                            :rules="[verificaPedimento, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                      </template>
                      <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu2 = false" >
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>

                  </v-flex>
                </v-layout>
                <v-layout row wrap>                  
                  <v-flex s12 m2 l2>
                    <v-autocomplete clearable v-model="model.tipo_operacion" :items="list_tipo_operaciones" :hide-no-data="true" :return-object="false" item-text="tipo" item-value="clave_tipo" label="Tipo Operación" >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex s12 m4 l4>
                    <v-autocomplete :loading="loading_claves" clearable v-model="model.clave_documento" :items="claves_documento" :hide-no-data="true" :return-object="false" item-text="nombre" item-value="clave" label="Clave Documento" >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex s12 m4 l4>
                    <v-text-field hint="Formato: 000-0000-0000000" label="Número Pedimento" type="text" v-model="model.pedimento" :rules="[verificaPedimento]" maxlength="20" ></v-text-field>
                  </v-flex>
                  <v-flex s12 m4 l1>
                    <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                      <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-row row wrap>
                  <v-col>
                    Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col sm="12" md="12" lg="12" >
                    <v-combobox v-model="lista_filtrada" label="Lista de archivos" multiple persistent-hint small-chips disabled color="green" >
                    </v-combobox>
                  </v-col>
                </v-row>
              </v-container>

            </v-card-text>

            <v-card-text>
              <span><strong>Tablas con información a nivel pedimento</strong></span>
              <v-container grid-list-md text-xs-center>
                <v-row no-gutters dense style="margin-bottom: -35px;" >
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="501 Datos Generales" value="501" :rules="[verificaTablas]" ></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="502 Transporte de Mercancías" value="502" ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row no-gutters dense style="margin-bottom: -35px;" >
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="503 Guías" value="503" ></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="504 Contenedores" value="504" ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row no-gutters dense style="margin-bottom: -35px;" >
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="505 Facturas" value="505" ></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="506 Fechas del Pedimento" value="506" ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row no-gutters dense style="margin-bottom: -35px;" >
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="507 Casos del Pedimento" value="507" ></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="508 Cuentas Aduaneras Garantía Pedimento" value="508" ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row no-gutters dense style="margin-bottom: -35px;" >
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="509 Tasas del Pedimento" value="509" ></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="510 Contribuciones del Pedimento" value="510" ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row no-gutters dense style="margin-bottom: -35px;" >
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="511 Observaciones del Pedimento" value="511" ></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="512 Descargos de Mercancía" value="512" ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row no-gutters dense style="margin-bottom: -35px;" >
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="520 Destinatarios de la Mercancía" value="520" ></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="701 Rectificaciones" value="701" ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row no-gutters dense style="margin-bottom: -35px;" >
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="702 Diferencias de Contribuciones del Pedimento" value="702" ></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-checkbox v-model="model.tablas" label="Selección Automatizada" value="Seleccion" ></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>

          <v-card-text>
            <span><strong>Tablas con información a nivel de partida (secuencia de la fracción arancelaria)</strong></span>
            <v-container grid-list-md text-xs-center>
              <v-row no-gutters dense style="margin-bottom: -35px;" >
                <v-col>
                  <v-checkbox v-model="model.tablas" label="551 Partidas" value="551" ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox v-model="model.tablas" label="552 Mercancías" value="552" ></v-checkbox>
                </v-col>
              </v-row>
              <v-row no-gutters dense style="margin-bottom: -35px;" >
                <v-col>
                  <v-checkbox v-model="model.tablas" label="553 Permisos de la Partida" value="553" ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox v-model="model.tablas" label="554 Casos de la Partida" value="554" ></v-checkbox>
                </v-col>
              </v-row>
              <v-row no-gutters dense style="margin-bottom: -35px;" >
                <v-col>
                  <v-checkbox v-model="model.tablas" label="555 Cuentas Aduaneras de Garantía de la Partida" value="555" ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox v-model="model.tablas" label="556 Tasas de las Contribuciones de la Partida" value="556" ></v-checkbox>
                </v-col>
              </v-row>
              <v-row no-gutters dense style="margin-bottom: -35px;" >
                <v-col>
                  <v-checkbox v-model="model.tablas" label="557 Contribuciones de la Partida" value="557" ></v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox v-model="model.tablas" label="558 Observaciones de la Partida" value="558" ></v-checkbox>
                </v-col>
              </v-row>
              <v-row no-gutters dense style="margin-bottom: -35px;" >
                <v-col>
                  <v-checkbox v-model="model.tablas" label="Incidencias del Reconocimiento Aduanero" value="Incidencias" ></v-checkbox>
                </v-col>
                <v-col></v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="success" @click="generar_reporte_sqs" >
              <v-icon>done</v-icon>Generar Reporte
            </v-btn>
          </v-card-actions>

          <v-card-text>
            <v-refresh-button :funcion="cargarReportesDS" />
            <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
              <template slot="noResults" >
                <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
              </template>

              <template slot="criterio" slot-scope="props" >
                <div class="columnaCriterio" >
                  {{ props.row.criterio }}
                </div>
              </template>

              <template slot="actions" slot-scope="props" >
                <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                  <v-icon dark>get_app</v-icon>
                </v-btn>
                <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                  <v-icon dark>delete</v-icon>
                </v-btn>
              </template>
            </v-client-table>
          </v-card-text>

        </base-material-card>




      </v-flex>
    </v-layout>
  </v-container>
  <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea</span><br>
        <small>*Usando esta opción no se tomarán en cuenta los valores en el campo pedimento ni fechas</small>
        <v-form ref="formListado" lazy-validation="" >
          <small><b>Consulta máxima de 50 pedimentos</b></small>
          <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]"></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="model.lista=''; lista_filtrada=[]; dialog1 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="setListValues();" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  data: () => ({
    dialog1: false,
    lista_filtrada: [],
    permisoEliminar: false,
    fab: false,
    loading_claves: true,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Datastage",
        disabled: true,
        to: ""
      },
      {
        text: "Consulta Directa DS",
        disabled: true,
        to: ""
      }
    ],
    datos: [],
    columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    show_loading: true,

    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      tipo_operacion: "",
      clave_documento: "",
      pedimento: "",
      tablas: [],
      reporte_url: "/reportes_ds/directo/",
      nombre_reporte: "Consulta Directa DS",
      tipo: "ReporteDirecto_DS",
    },

    claves_documento: [],
    list_tipo_operaciones: [{
        "tipo": "Importación",
        "clave_tipo": "1"
      },
      {
        "tipo": "Exportación",
        "clave_tipo": "2"
      },
    ],

    selecciona_todo: false,


    menu1: false,
    menu2: false,

    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    }
  }),

  methods: {
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."

      return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    maxListaRule: function() {
      if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
        return "Lista vacia";
      }

      let x = this.model.lista.split("\n");

      if (x.length > 50) {
        return "No se puede consultar mas de 50 pedimentos";
      }

      return true;
    },
    verificaTablas: function() {
      if (this.model.tablas.length == 0)
        return "Debe seleccionar al menos una tabla";
      else
        return true;
    },
    verificaPedimento: function() {
      if (this.model.lista != '' && this.model.lista != null && this.model.lista.length > 0) {
        return true;
      }
      if (this.model.fecha_de == "" || this.model.fecha_a == "") {
        if (this.model.pedimento == "") {
          return "Favor de ingresar fechas o número de pedimento";
        }
      }
      return true;
    },
    pushTable: function(tabla) {
      var i = this.model.tablas.indexOf(tabla);
      if (i !== -1) {
        this.model.tablas.splice(i, 1);
      } else
        this.model.tablas.push(tabla);

      console.log(this.model.tablas);
      console.log(this.ds501);
    },
    seleccionaTodo: function() {
      if (this.selecciona_todo == true) {
        this.model.tablas = ["501", "502", "503", "504", "505", "506", "507", "508", "509", "510", "511", "512",
          "520", "551", "552", "553", "554", "555", "556", "557", "558",
          "701", "702", "Incidencias", "Seleccion"
        ];
      } else {
        this.model.tablas = [];
      }
    },
    cargarReportesDS: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "ReporteDirecto_DS"
      };
      axios.post(this.URL + "get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos) {
              this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
              this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
              this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
              this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes ds.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    cargarClavesDocumento: function() {
      this.loading_claves = true;
      let data = {
        tabla: 13, //13-Claves de Pedimentos
      };
      axios.post(this.$hostname + "apendices/lista/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.claves_documento = res.data;
            for (var k in this.claves_documento) {
              this.claves_documento[k].nombre = this.claves_documento[k].clave + " - " + this.claves_documento[k].descripcion;
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las claves de documentos.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.loading_claves = false;
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          var result = ""
          if (params.pedimento != "")
            result += "\nPedimento: " + params.pedimento;
          else {
            if (params.lista != undefined && params.lista != "" && params.lista.length > 0) {
              result += "Búsqueda por Lista.";
            } else {
              result += "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;

            }
            if (params.tipo_operacion != undefined && params.tipo_operacion != "")
              result += "\nOperacion: " + params.tipo_operacion + ", ";
            if (params.clave_documento != undefined && params.clave_documento != "")
              result += "Clave: " + params.clave_documento;
          }
          if (params.tablas != undefined && params.tablas.length > 0) {
            if (params.tablas.length == 25)
              result += "\nTodas las secciones";
            else {
              result += "\nSecciones: " + params.tablas;
            }
          }

          return result;
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },

    generar_reporte_sqs() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {

        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        var data = this.model;
        if (data.lista == '' || data.lista == []) {
          delete(data['lista']);
        } else {
          data['lista'] = this.get_array_lista(data['lista']);
        }
        axios({
            method: "post",
            url: this.$hostname + "reportes/save_reporte/",
            data: data
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.model.lista = '';
            this.lista_filtrada = [];
            this.cargarReportesDS();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },

    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportesDS();
            });
        }
      });

    },
    setListValues: function() {
      this.lista_filtrada = [];
      let to_list = this.get_array_lista(this.model.lista);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada.push(to_list[i]);
        }
      }
      this.dialog1 = !this.dialog1;
    },
    get_array_lista: function(cadena) {
      try {
        var newarr = [];
        if (cadena != undefined){
          let data = cadena.split("\n");
          newarr = data.filter(a => a.trim() !== '');
          for (var i = 0; i < newarr.length; i++) {
            newarr[i] = newarr[i].trim();
            newarr[i] = newarr[i].replace(',', '');
            newarr[i] = newarr[i].replace('.', '');
          }
        }
        return newarr;
      } catch (error) {
        console.log(error);
      }

    },
  }, //methods
  created: function() {
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.URL = this.$hostname + "reportes/";
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
      this.permisoEliminar = true;
    this.cargarReportesDS();
    this.cargarClavesDocumento();

  }
};
</script>
<style scoped>
.elevation-1>>>.v-label.theme--light {
  color: black !important;
}

.elevation-1>>>.v-input--has-state>div:nth-child(1)>div:nth-child(2) {
  margin-top: -10px;
}

.elevation-1>>>.columnaCriterio {
  white-space: normal !important;
  min-width: 400px !important;
  text-align: justify !important;
}
</style>
